import {
  createSlice, PayloadAction, createAsyncThunk,
} from '@reduxjs/toolkit';
import { doLogin, doLogout } from '../../common/request';
import { clearData } from '../customer/_slice';

interface LoginState {
  isLoggingIn: boolean;
  errMsg?: string | null;
}

const initialState: LoginState = {
  isLoggingIn: false,
};

// Handle actions in your reducers
const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setLoggingIn: (state) => {
      state.isLoggingIn = true;
      state.errMsg = null;
    },
    setResult: (state, action: PayloadAction<string | null>) => {
      state.isLoggingIn = false;
      state.errMsg = action.payload;
    },
    clearResult: (state) => {
      state.isLoggingIn = false;
      state.errMsg = null;
    }
  },
});

export const login = createAsyncThunk<number, { apiKey: string }>(
  'login/login',
  async (params, thunkAPI) => {
    thunkAPI.dispatch(loginSlice.actions.setLoggingIn());
    try {
      const customerCount = await doLogin(params.apiKey);
      if (customerCount > 0) {
        thunkAPI.dispatch(loginSlice.actions.setResult(null));
        return customerCount;
      }
      thunkAPI.dispatch(loginSlice.actions.setResult('Login failed'));
      return 0;
    } catch (err) {
      thunkAPI.dispatch(loginSlice.actions.setResult('Login failed'));
      return 0;
    }
  },
);

export const logout = createAsyncThunk<void>(
  'login/logout',
  async (_, thunkAPI) => {
    thunkAPI.dispatch(clearData());
    await doLogout();
  },
);

export const {
  clearResult,
} = loginSlice.actions;
export default loginSlice.reducer;